export const LEADERBOARD_FETCH_THROTTLING_TIME = 60000;
